// Function to calculate percentage and convert it to float
export function calculateMeshRadiusPoint(min: number, max: number, defaultValue: number, currentValue: number, skipValidation?: boolean): { percentage: number; floatValue: number } {
  // Validate input to ensure min < max and defaultValue within range
  if (!skipValidation) {
    if (min >= max) {
      throw new Error('Minimum value must be less than maximum value.');
    }

    if (defaultValue < min || defaultValue > max) {
      throw new Error('Default value must be within the range of minimum and maximum values.');
    }

    if (currentValue < min || currentValue > max) {
      throw new Error('Current value must be within the range of minimum and maximum values.');
    }

  }

  // Calculate the percentage based on default value as 100%
  const range = max - min;
  const percentage = ((currentValue - min) / (defaultValue - min)) * 100;

  // Calculate float value based on percentage
  const floatValue = percentage / 100;

  return {
    percentage: parseFloat(percentage.toFixed(2)), // Rounded to 2 decimal places
    floatValue: parseFloat(floatValue.toFixed(2)), // Rounded to 2 decimal places
  };
}

// // Example usage
// const min = 0;
// const max = 430;
// const currentValue = 300; // Example slider value

// const result = calculateMeshRadiusPoint(min, max, currentValue);
// console.log(`Percentage: ${result.percentage}%`); // Example: 113.21%
// console.log(`Float value: ${result.floatValue}`); // Example: 1.13
